<template>
  <div style="white-space: nowrap">
    <select
      v-model="shift.values.driver"
      v-bind:disabled="
        (shift.values.locked && shift.values.locked != '0') || disabled
      "
      :class="drivers.class"
      @change="changeSelect(shift.values.driver)"
    >
      <option class="unavailable" value="" :selected="!shift.values.driver"
        >[{{ getNumAvailableDrivers }}] Kies een chauffeur</option
      >
      <template v-for="(optionGroup, optionGroupIndex) in drivers.optionGroups">
        <optgroup
          :key="optionGroupIndex"
          v-if="optionGroup.options.length > 0"
          :class="optionGroup.class"
          :label="optionGroup.label"
        >
          <option
            v-for="(option, optionIndex) in optionGroup.options"
            :key="optionIndex"
            v-bind:value="option.value"
            >{{ option.label }}</option
          >
        </optgroup>
      </template>
    </select>
    <schedule-editor-item-checkbox
      v-model="shift.values.locked"
      :disabled="disabled"
      :checked="shift.values.locked"
    ></schedule-editor-item-checkbox>
  </div>
</template>

<script>
import scheduleEditorItemCheckbox from "./ScheduleEditorItemCheckbox.vue";

export default {
  data() {
    return {};
  },
  computed: {
    getSelectToolTip: function() {
      try {
        return this.languageDetails.schedule.shift.dropdown.toolTip;
      } catch (e) {
        return "";
      }
    },
    getNumAvailableDrivers: function() {
      try {
        let val = this.getNumPrimaryAvailableDrivers;

        if (this.shift.drivers.secondary !== undefined) {
          val = val + "-" + this.getNumSecondaryAvailableDrivers;
        }

        if (this.shift.drivers.tertiary !== undefined) {
          val = val + "-" + this.getNumTertiaryAvailableDrivers;
        }

        return val;
      } catch (e) {
        return 0;
      }
    },
    getNumPrimaryAvailableDrivers: function() {
      try {
        return this.drivers.optionGroups["primary"].options.length;
      } catch (e) {
        return 0;
      }
    },
    getNumSecondaryAvailableDrivers: function() {
      try {
        return this.drivers.optionGroups["secondary"].options.length;
      } catch (e) {
        return 0;
      }
    },
    getNumTertiaryAvailableDrivers: function() {
      try {
        return this.drivers.optionGroups["tertiary"].options.length;
      } catch (e) {
        return 0;
      }
    },
    getCheckboxToolTip: function() {
      try {
        return this.languageDetails.schedule.shift.checkbox.toolTip;
      } catch (e) {
        return "";
      }
    },
    shift: function() {
      let data = this.data.groups[this.dataGroupIndex].routes[
        this.dataRouteIndex
      ].shifts[this.dataShiftIndex];
      if (data.values.driver === null) {
        data.values.driver = "";
      }
      return data;
    },
    shifts: function() {
      var shiftData = [];
      for (var group in this.data.groups) {
        for (var route in this.data.groups[group].routes) {
          for (var shift in this.data.groups[group].routes[route].shifts) {
            shiftData.push(this.data.groups[group].routes[route].shifts[shift]);
          }
        }
      }
      return shiftData;
    },
    drivers: function() {
      var data = {
        optionGroups: {
          primary: {
            label: "Beschikbaar",
            class: "primary",
            options: []
          },
          secondary: {
            label: "Beschikbaar (2e)",
            class: "secondary",
            options: []
          },
          tertiary: {
            label: "Beschikbaar (3e)",
            class: "tertiary",
            options: []
          },
          "overlap-shifts": {
            label: "Diensten overlap",
            class: "overlap-shifts",
            options: []
          },
          "max-shifts": {
            label: "Maximum aantal diensten bereikt",
            class: "max-shifts",
            options: []
          },
          optional: {
            label: "Eventueel beschikbaar",
            class: "optional",
            options: []
          },
          unavailable: {
            label: "Niet beschikbaar",
            class: "unavailable",
            options: []
          }
        },
        class: "unavailable"
      };

      var groupOptions = [];
      var driver = "";
      // Populate unavailable
      for (var i in this.shift.drivers.unavailable) {
        driver = this.getDriverById(this.shift.drivers.unavailable[i]);
        // console.log(this.shift.drivers.unavailable[i]);

        groupOptions.push({
          label:
            "(" +
            driver.shiftsScheduled.length +
            "/" +
            driver.maxShifts +
            ") " +
            driver.firstName +
            " " +
            (driver.lastNamePrefix ? driver.lastNamePrefix + " " : "") +
            driver.lastName,
          value: driver.id,
          fieldForSorting: this.driverNameForSorting(driver)
        });
        if (driver.id === this.shift.values.driver) {
          data.class = data.optionGroups["unavailable"].class;
        }
      }
      data.optionGroups["unavailable"].options = this.sortCollection(
        groupOptions,
        "fieldForSorting",
        "asc"
      );
      // console.log(data);

      // Populate optional
      groupOptions = [];
      for (var i in this.shift.drivers.optional) {
        driver = this.getDriverById(this.shift.drivers.optional[i]);
        // console.log(this.shift.drivers.optional[i]);

        groupOptions.push({
          label:
            "(" +
            driver.shiftsScheduled.length +
            "/" +
            driver.maxShifts +
            ") " +
            driver.firstName +
            " " +
            (driver.lastNamePrefix ? driver.lastNamePrefix + " " : "") +
            driver.lastName,
          value: driver.id,
          fieldForSorting: this.driverNameForSorting(driver)
        });
        if (driver.id === this.shift.values.driver) {
          data.class = data.optionGroups["optional"].class;
        }
      }
      data.optionGroups["optional"].options = this.sortCollection(
        groupOptions,
        "fieldForSorting",
        "asc"
      );
      // console.log(data);

      // Populate overlap shifts
      groupOptions = [];
      for (var i in this.shift.drivers.primary) {
        driver = this.getDriverById(this.shift.drivers.primary[i]);

        for (var shiftIndex in this.shifts) {
          if (driver.id !== this.shifts[shiftIndex].values.driver) {
            continue;
          }
          if (
            this.shifts[shiftIndex].id === this.shift.id &&
            this.shifts[shiftIndex].routeId === this.shift.routeId
          ) {
            continue;
          }

          if (this.shifts[shiftIndex].endTime <= this.shift.beginTime) {
            continue;
          }
          if (this.shifts[shiftIndex].beginTime >= this.shift.endTime) {
            continue;
          }

          groupOptions.push({
            label:
              "(" +
              driver.shiftsScheduled.length +
              "/" +
              driver.maxShifts +
              ") " +
              driver.firstName +
              " " +
              (driver.lastNamePrefix ? driver.lastNamePrefix + " " : "") +
              driver.lastName,
            value: driver.id,
            fieldForSorting: this.driverNameForSorting(driver)
          });
          if (driver.id === this.shift.values.driver) {
            data.class = data.optionGroups["overlap-shifts"].class;
          }
        }
      }
      if (this.shift.drivers.secondary !== undefined) {
        for (var i in this.shift.drivers.secondary) {
          driver = this.getDriverById(this.shift.drivers.secondary[i]);

          for (var shiftIndex in this.shifts) {
            if (driver.id !== this.shifts[shiftIndex].values.driver) {
              continue;
            }
            if (
              this.shifts[shiftIndex].id === this.shift.id &&
              this.shifts[shiftIndex].routeId === this.shift.routeId
            ) {
              continue;
            }

            if (this.shifts[shiftIndex].endTime <= this.shift.beginTime) {
              continue;
            }
            if (this.shifts[shiftIndex].beginTime >= this.shift.endTime) {
              continue;
            }

            groupOptions.push({
              label:
                "(" +
                driver.shiftsScheduled.length +
                "/" +
                driver.maxShifts +
                ") " +
                driver.firstName +
                " " +
                (driver.lastNamePrefix ? driver.lastNamePrefix + " " : "") +
                driver.lastName,
              value: driver.id,
              fieldForSorting: this.driverNameForSorting(driver)
            });
            if (driver.id === this.shift.values.driver) {
              data.class = data.optionGroups["overlap-shifts"].class;
            }
          }
        }
      }
      if (this.shift.drivers.tertiary !== undefined) {
        for (var i in this.shift.drivers.tertiary) {
          driver = this.getDriverById(this.shift.drivers.tertiary[i]);

          for (var shiftIndex in this.shifts) {
            if (driver.id !== this.shifts[shiftIndex].values.driver) {
              continue;
            }
            if (
              this.shifts[shiftIndex].id === this.shift.id &&
              this.shifts[shiftIndex].routeId === this.shift.routeId
            ) {
              continue;
            }

            if (this.shifts[shiftIndex].endTime <= this.shift.beginTime) {
              continue;
            }
            if (this.shifts[shiftIndex].beginTime >= this.shift.endTime) {
              continue;
            }

            groupOptions.push({
              label:
                "(" +
                driver.shiftsScheduled.length +
                "/" +
                driver.maxShifts +
                ") " +
                driver.firstName +
                " " +
                (driver.lastNamePrefix ? driver.lastNamePrefix + " " : "") +
                driver.lastName,
              value: driver.id,
              fieldForSorting: this.driverNameForSorting(driver)
            });
            if (driver.id === this.shift.values.driver) {
              data.class = data.optionGroups["overlap-shifts"].class;
            }
          }
        }
      }
      data.optionGroups["overlap-shifts"].options = this.sortCollection(
        groupOptions,
        "fieldForSorting",
        "asc"
      );
      // console.log(data);

      // Populate max shifts
      groupOptions = [];
      for (var i in this.shift.drivers.primary) {
        driver = this.getDriverById(this.shift.drivers.primary[i]);
        // console.log(this.shift.drivers.primary[i]);

        if (
          this.doesDriverExistsInOptions(
            data.optionGroups["overlap-shifts"].options,
            driver.id
          )
        ) {
          continue;
        }

        let shiftsToday = this.getScheduledShiftsForDate(
          this.shift.date,
          driver.shiftsScheduled
        );
        if (
          (this.dataMaxShiftsPerDay === 0 ||
            shiftsToday < this.dataMaxShiftsPerDay ||
            (shiftsToday === this.dataMaxShiftsPerDay &&
              this.shift.values.driver === driver.id)) &&
          (driver.shiftsScheduled.length < driver.maxShifts ||
            (driver.shiftsScheduled.length === driver.maxShifts &&
              this.shift.values.driver === driver.id))
        ) {
          continue;
        }

        groupOptions.push({
          label:
            "(" +
            driver.shiftsScheduled.length +
            "/" +
            driver.maxShifts +
            ") " +
            driver.firstName +
            " " +
            (driver.lastNamePrefix ? driver.lastNamePrefix + " " : "") +
            driver.lastName,
          value: driver.id,
          fieldForSorting: this.driverNameForSorting(driver)
        });
        if (driver.id === this.shift.values.driver) {
          data.class = data.optionGroups["max-shifts"].class;
        }
      }
      if (this.shift.drivers.secondary !== undefined) {
        for (var i in this.shift.drivers.secondary) {
          driver = this.getDriverById(this.shift.drivers.secondary[i]);
          // console.log(this.shift.drivers.primary[i]);

          if (
            this.doesDriverExistsInOptions(
              data.optionGroups["overlap-shifts"].options,
              driver.id
            )
          ) {
            continue;
          }

          let shiftsToday = this.getScheduledShiftsForDate(
            this.shift.date,
            driver.shiftsScheduled
          );
          if (
            (this.dataMaxShiftsPerDay === 0 ||
              shiftsToday < this.dataMaxShiftsPerDay ||
              (shiftsToday === this.dataMaxShiftsPerDay &&
                this.shift.values.driver === driver.id)) &&
            (driver.shiftsScheduled.length < driver.maxShifts ||
              (driver.shiftsScheduled.length === driver.maxShifts &&
                this.shift.values.driver === driver.id))
          ) {
            continue;
          }

          groupOptions.push({
            label:
              "(" +
              driver.shiftsScheduled.length +
              "/" +
              driver.maxShifts +
              ") " +
              driver.firstName +
              " " +
              (driver.lastNamePrefix ? driver.lastNamePrefix + " " : "") +
              driver.lastName,
            value: driver.id,
            fieldForSorting: this.driverNameForSorting(driver)
          });
          if (driver.id === this.shift.values.driver) {
            data.class = data.optionGroups["max-shifts"].class;
          }
        }
      }
      if (this.shift.drivers.tertiary !== undefined) {
        for (var i in this.shift.drivers.tertiary) {
          driver = this.getDriverById(this.shift.drivers.tertiary[i]);
          // console.log(this.shift.drivers.primary[i]);

          if (
            this.doesDriverExistsInOptions(
              data.optionGroups["overlap-shifts"].options,
              driver.id
            )
          ) {
            continue;
          }

          let shiftsToday = this.getScheduledShiftsForDate(
            this.shift.date,
            driver.shiftsScheduled
          );
          if (
            (this.dataMaxShiftsPerDay === 0 ||
              shiftsToday < this.dataMaxShiftsPerDay ||
              (shiftsToday === this.dataMaxShiftsPerDay &&
                this.shift.values.driver === driver.id)) &&
            (driver.shiftsScheduled.length < driver.maxShifts ||
              (driver.shiftsScheduled.length === driver.maxShifts &&
                this.shift.values.driver === driver.id))
          ) {
            continue;
          }

          groupOptions.push({
            label:
              "(" +
              driver.shiftsScheduled.length +
              "/" +
              driver.maxShifts +
              ") " +
              driver.firstName +
              " " +
              (driver.lastNamePrefix ? driver.lastNamePrefix + " " : "") +
              driver.lastName,
            value: driver.id,
            fieldForSorting: this.driverNameForSorting(driver)
          });
          if (driver.id === this.shift.values.driver) {
            data.class = data.optionGroups["max-shifts"].class;
          }
        }
      }
      data.optionGroups["max-shifts"].options = this.sortCollection(
        groupOptions,
        "fieldForSorting",
        "asc"
      );
      // console.log(data);

      // Populate primary
      groupOptions = [];
      for (var i in this.shift.drivers.primary) {
        driver = this.getDriverById(this.shift.drivers.primary[i]);
        // console.log(this.shift.drivers.primary[i]);

        if (
          this.doesDriverExistsInOptions(
            data.optionGroups["max-shifts"].options,
            driver.id
          )
        ) {
          continue;
        }
        if (
          this.doesDriverExistsInOptions(
            data.optionGroups["overlap-shifts"].options,
            driver.id
          )
        ) {
          continue;
        }

        groupOptions.push({
          label:
            "(" +
            driver.shiftsScheduled.length +
            "/" +
            driver.maxShifts +
            ") " +
            driver.firstName +
            " " +
            (driver.lastNamePrefix ? driver.lastNamePrefix + " " : "") +
            driver.lastName,
          value: driver.id,
          fieldForSorting: this.driverNameForSorting(driver)
        });
        if (driver.id === this.shift.values.driver) {
          data.class = data.optionGroups["primary"].class;
        }
      }
      data.optionGroups["primary"].options = this.sortCollection(
        groupOptions,
        "fieldForSorting",
        "asc"
      );
      // console.log(data.optionGroups);

      // Populate secondary
      if (this.shift.drivers.secondary !== undefined) {
        groupOptions = [];
        for (var i in this.shift.drivers.secondary) {
          driver = this.getDriverById(this.shift.drivers.secondary[i]);
          // console.log(this.shift.drivers.secondary[i]);

          if (
            this.doesDriverExistsInOptions(
              data.optionGroups["max-shifts"].options,
              driver.id
            )
          ) {
            continue;
          }
          if (
            this.doesDriverExistsInOptions(
              data.optionGroups["overlap-shifts"].options,
              driver.id
            )
          ) {
            continue;
          }

          groupOptions.push({
            label:
              "(" +
              driver.shiftsScheduled.length +
              "/" +
              driver.maxShifts +
              ") " +
              driver.firstName +
              " " +
              (driver.lastNamePrefix ? driver.lastNamePrefix + " " : "") +
              driver.lastName,
            value: driver.id,
            fieldForSorting: this.driverNameForSorting(driver)
          });
          if (driver.id === this.shift.values.driver) {
            data.class = data.optionGroups["secondary"].class;
          }
        }
        data.optionGroups["secondary"].options = this.sortCollection(
          groupOptions,
          "fieldForSorting",
          "asc"
        );
        // console.log(data.optionGroups);
      }

      // Populate tertiary
      if (this.shift.drivers.tertiary !== undefined) {
        groupOptions = [];
        for (var i in this.shift.drivers.tertiary) {
          driver = this.getDriverById(this.shift.drivers.tertiary[i]);
          // console.log(this.shift.drivers.tertiary[i]);

          if (
            this.doesDriverExistsInOptions(
              data.optionGroups["max-shifts"].options,
              driver.id
            )
          ) {
            continue;
          }
          if (
            this.doesDriverExistsInOptions(
              data.optionGroups["overlap-shifts"].options,
              driver.id
            )
          ) {
            continue;
          }

          groupOptions.push({
            label:
              "(" +
              driver.shiftsScheduled.length +
              "/" +
              driver.maxShifts +
              ") " +
              driver.firstName +
              " " +
              (driver.lastNamePrefix ? driver.lastNamePrefix + " " : "") +
              driver.lastName,
            value: driver.id,
            fieldForSorting: this.driverNameForSorting(driver)
          });
          if (driver.id === this.shift.values.driver) {
            data.class = data.optionGroups["tertiary"].class;
          }
        }
        data.optionGroups["tertiary"].options = this.sortCollection(
          groupOptions,
          "fieldForSorting",
          "asc"
        );
        // console.log(data.optionGroups);
      }

      for (var i in data.optionGroups) {
        for (var j in data.optionGroups[i].options) {
          data.optionGroups[i].options[j]["label"] =
            "[" +
            data.optionGroups["primary"].options.length +
            (this.shift.drivers.secondary !== undefined
              ? "-" + data.optionGroups["secondary"].options.length
              : "") +
            (this.shift.drivers.tertiary !== undefined
              ? "-" + data.optionGroups["tertiary"].options.length
              : "") +
            "] " +
            data.optionGroups[i].options[j]["label"];
        }
      }

      return data;
    }
  },
  props: [
    "helpToolTipsEnabled",
    "driverDetails",
    "languageDetails",
    "data",
    "dataDayIndex",
    "dataGroupIndex",
    "dataRouteIndex",
    "dataShiftIndex",
    "disabled",
    "dataMaxShiftsPerDay"
  ],
  components: {
    scheduleEditorItemCheckbox: scheduleEditorItemCheckbox
  },
  watch: {
    // selectValue: function (newValue, oldValue) {
    //     console.log("Driver changed from " + oldValue + ' to ' + newValue);
    //     this.$emit('change', newValue);
    // },
    // values: function (newValue, oldValue) {
    //     // console.log("Driver changed from " + oldValue + ' to ' + newValue);
    //     // this.$emit('change', newValue); // @todo Check if needed
    // },
    // values: {
    //     handler (val) {
    //         console.log("Driver change " + val);
    //         // this.$emit('change', newValue);
    //         this.emit();
    //     },
    //     deep: true
    // }
    data: {
      handler(val) {
        this.changeSelect();
      },
      deep: true
    }
    // class: function (newValue, oldValue){
    //     console.log("class changed from " + oldValue + ' to ' + newValue);
    // }
  },
  methods: {
    changeSelect() {
      this.updateDriverAvailabilityValue();
    },
    getDriverById: function(id) {
      // for (var i in this.driverDetails) {
      //     if (this.driverDetails[i].id == id) {
      //         return this.driverDetails[i];
      //     }
      // }
      // console.log('Driver not found (' + id + ') in ' + this.driverDetails.length);
      // console.log(this.driverDetails);

      if (this.driverDetails[id] !== undefined) {
        return this.driverDetails[id];
      }

      return {
        id: "",
        firstName: "",
        lastNamePrefix: "",
        lastName: "",
        city: "",
        phone: "",
        mobile: "",
        maxShifts: "0",
        slotsAvailable: "0",
        shiftsScheduled: []
      };
    },
    doesDriverExistsInOptions: function(options, driverId) {
      for (var option in options) {
        if (options[option].value == driverId) {
          return true;
        }
      }
      return false;
    },
    driverNameForSorting: function(driver) {
      return (
        driver.lastName +
        " " +
        (driver.lastNamePrefix ? driver.lastNamePrefix + " " : "") +
        driver.firstName
      );
    },
    updateDriverAvailabilityValue() {
      if (this.drivers.class === "primary") {
        this.shift.values.availability = 1;
      } else if (this.drivers.class === "secondary") {
        this.shift.values.availability = 2;
      } else if (this.drivers.class === "tertiary") {
        this.shift.values.availability = 3;
      } else if (this.drivers.class === "unavailable") {
        this.shift.values.availability = 9;
      } else if (this.drivers.class === "optional") {
        this.shift.values.availability = 8;
      } else if (this.drivers.class === "overlap-shifts") {
        this.shift.values.availability = 6;
      } else if (this.drivers.class === "max-shifts") {
        this.shift.values.availability = 5;
      }

      return true;
    },
    getScheduledShiftsForDate(date, datesScheduled) {
      let found = 0;
      for (let i in datesScheduled) {
        if (datesScheduled[i] !== date) {
          continue;
        }

        found++;
      }

      return found;
    }
    // emit() {
    //     this.$emit('change', this.values);
    // }
  },
  updated() {},
  created() {
    // this.optionGroups = this.data.optionGroups;
    // this.values = this.data.values;
    // this.values.locked = (this.values.locked && this.values.locked != "0") ? true : false
  },
  mounted() {
    // console.log('Schedule Item component mounted.')
    this.updateDriverAvailabilityValue();
  }
};
</script>

<style lang="scss" scoped>
.checkbox {
  border: 1px solid #d2d2d2;
  width: 22px;
  height: 22px;
  margin-left: 4px;
}

.checkbox.checked svg path.checkmark {
  fill: #636b6f;
}

select:hover {
  cursor: pointer;
}

select,
select.unavailable,
select optgroup,
select.unavailable optgroup,
select optgroup option,
select.unavailable optgroup option,
select option,
select.unavailable option {
  border: 1px solid #d2d2d2;
  border-radius: 3px;
  padding: 3px;
  background-color: #f44336;
  width: 90%;
  margin-bottom: 0px;
  color: #fff;
}

select.primary,
select optgroup.primary,
select optgroup.primary option {
  background-color: #4caf50;
}

select.secondary,
select optgroup.secondary,
select optgroup.secondary option {
  background-color: #388e3c;
}

select.tertiary,
select optgroup.tertiary,
select optgroup.tertiary option {
  background-color: #1b5e20;
}

select.optional,
select optgroup.optional,
select optgroup.optional option {
  background-color: #7cb342;
}

select.max-shifts,
select optgroup.max-shifts,
select optgroup.max-shifts option {
  background-color: #7c4dff;
}

select.overlap-shifts,
select optgroup.overlap-shifts,
select optgroup.overlap-shifts option {
  background-color: #ff9800;
}

select[disabled="disabled"] {
  cursor: default;
}
</style>
